import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=6a909e0e&scoped=true&"
import script from "./safe.vue?vue&type=script&lang=ts&"
export * from "./safe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a909e0e",
  null
  
)

export default component.exports